import { Record, List } from "immutable";

const defaultValues = {
  locationId: null,
  id: null,
  title: null,
  description: null,
  sizeTypeItemId: null,
  designTypeItemId: null,
  designTypeName: null,
  menuId: null,
  menuDescription: null,
  userProcessStep: null,
  ordinal: null,
  created: null,
  createdBy: null,
  updated: null,
  updatedBy: null,
  designVersions: null,
  designPages: null,
  previewUrl: null,
  imported: false,
};

export default class RecentDesign extends Record(defaultValues, RecentDesign) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const RecentDesigns = (data) => {
  let recentDesigns = new List();
  if (data) {
    data.forEach((value) => {
      recentDesigns = recentDesigns.push(new RecentDesign(value));
    });
  }
  return recentDesigns;
};
